import { Component, OnInit } from '@angular/core';
import { TipoMenu } from 'src/app/_enums/TipoMenu';
import { Formulario } from 'src/app/_models';
import { TipoFormulario } from 'src/app/_enums/TipoFormulario';

@Component({
  selector: 'app-vendas-telefone',
  templateUrl: './vendas-telefone.component.html'
})
export class VendasTelefoneComponent implements OnInit {

  public form = new Formulario();
  public tipoMenuValue: number = TipoMenu.Checkup;

  constructor() { 
    this.definirProprForm();
  }

  ngOnInit() {
  }

  private definirProprForm(): void {
    this.form.id = TipoFormulario.VendasTelefone;
    this.form.link = TipoFormulario.VendasTelefoneRouterLink;
    this.form.descricao = TipoFormulario.VendasTelefoneDescription;

    localStorage.setItem('currentForm', JSON.stringify(this.form));
  }

}